<template>
    <div class="treeframe">
        <Tree :pattern="pattern(step)" />
    </div>
</template>

<script>
import Tree from './Tree'
export default {
  name: 'Treeframe',
  components: {
    Tree
  },
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getRandomIntInclusive (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    pattern (i) {
      if (i < 5) {
        return 0
      } else {
        // console.log(i)
        return this.getRandomIntInclusive(1, 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.treeframe {
  position: relative;
  width: 100vw;
  height: 600px;
  @include respond-to(sm) {
    height: 800px;
  }
  @include respond-to('1200') {
    height: 100vh;
  }
  flex-shrink: 0;
}
</style>
